<mat-form-field
  appearance="outline"
  subscriptSizing="dynamic"
  class="time-input"
>
  <mat-label>Select Time</mat-label>
  <input
    matInput
    [value]="timeControl.value"
    [formControl]="timeControl"
    [matMenuTriggerFor]="timeMenu"
    readonly
  />
  <mat-icon matPrefix class="material-symbols-outlined">schedule</mat-icon>
  @if (timeControl.hasError("required") && timeControl.touched) {
    <mat-error>
      {{ eventMessages.TIME_REQUIRED }}
    </mat-error>
  }
  @if (timeControl.hasError("endTimeAfterStartTime")) {
    <mat-error class="matError">
      {{ eventMessages.END_BEFORE_START_TIME }}
    </mat-error>
  }
  @if (timeControl.hasError("timeInPast")) {
    <mat-error class="matError">
      {{ eventMessages.PAST_START_TIME }}
    </mat-error>
  }
</mat-form-field>

<mat-menu #timeMenu="matMenu" class="time-picker-menu">
  <section class="time-options">
    @for (time of timeOptions; track time) {
      <button mat-button class="time-button" (click)="selectTime(time)">
        {{ time }}
      </button>
    }
  </section>
</mat-menu>
